import axios from 'axios'
import library from '../../../utils/Library'

export const helpGetAllOrganizationCorpEntities = async (params) => {
  const TOKEN = sessionStorage.getItem('token')

  const URL =
    library.getBaseAPIUrl('organization') + '/getAllOrganizationCorpEntities'

  return await axios.get(URL, {
    headers: {
      Authorization: `Bearer ${TOKEN}`
    },
    params: params
    // {
    //   organizationName: 'CGI'
    //   "organizationName": "CONTADORES",
    //   "organizationLegalName": "ESTUDIO",
    //   "organizationTypeCode": "ASSOCIATION",
    //   "asc": "organizationId",
    //   "order": "ASC"
    // }
  })
}
